<template>
  <div class="row">
    <header>
      <div class="row no-gutters justify-content-md-between mt-4 ml-5">
        <div class="col-md-10 header-title">
          <img src="@/assets/ey-logo.svg" alt="EY" height="40" width="40" />
          <span class="ml-4">
           EYTaxSpace 
            <sup>TM</sup>&nbsp; | &nbsp;Employee Unit Management&nbsp; | &nbsp;Tishman Speyer &nbsp;</span>
          </span>
        </div>
        <div class="col-md-2 user">
          <span v-if="user">
            <i class="fa fa-user"></i>
            &nbsp;&nbsp;{{ user }}
          </span>&nbsp;
          <span v-if="user" class="k-icon k-i-gear"></span>
          <span v-if="user" class="menuDisplay">
            <a href="\#" data-toggle="dropdown" class="dropdown-toggle">
              <ul class="dropdown-menu">
             
                <li>
                  <a href="\#" @click.prevent="Logout">
                    <i class="fa fa-power-off" aria-hidden="true"></i> &nbsp;Logout
                  </a>
                </li>
                <li>
                  <a href="\#" @click.prevent="GetToken">
                    <i class="fa fa-key" aria-hidden="true"></i> &nbsp;Token </a>
                </li>
              </ul>
            </a>
          </span>
        </div>
      </div>
      <div v-if="user" keyval="main-routes" class="row no-gutters mt-2 pl-5">
        <nav
          class="navbar navbar-expand-lg navbar-expand-md navbar-expand-sm navbar-expand-xl navbar-dark" 
          style="padding-left: 16px !important;padding-right: 16px !important;padding-top: 8px !important;">
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item" v-for="navItem in mainRoutes" :key="navItem.name">
                <a
                  @mouseover="routerAction(navItem.name)"
                  @mouseout="routerAction(initialroute)"
                  v-on:click="routerAction(navItem.name)"
                >
                  <router-link
                    class="nav-link"
                    :to="navItem.route"
                    :class="{'router-link-active': subIsActive('/'+navItem.name)}"
                  >{{navItem.label}}</router-link>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <nav
        class="navbar navbar-expand-lg navbar-expand-md navbar-expand-sm navbar-expand-xl navbar-dark subnavbar"
        v-show="submenu"
      >
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li
              class="nav-item"
              v-for="routes in SubRoutes"
              :key="routes.label"
              v-on:click="routerAction(routes.name)"
              @mouseover="routerAction(routes.name)"
              @mouseout="routerAction(initialroute)"
            >
              <router-link class="nav-link" :to="routes.route">{{routes.label}}</router-link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  </div>
</template>

<script>
import cookieUtil from "@/services/cookieUtil.js";
import funcUtil from '../../services/funcUtil';
import Swal from 'sweetalert2/dist/sweetalert2.js'

//import auth from "@/services/auth.js";
import localStorageService from '../../services/localStorageService';

export default {
  name: "Header",
  mixins: [cookieUtil,funcUtil],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    user: String
  },
  data() {
    return {
      navItem: {},
      SubRoutes: [],
      submenu: false,
      mainRoutes: [],
      initialroute: ""
    };
  },
  computed: {
    $eumAuth: function(){
        return this.$root.$eumAuth;
      },
      $msalClient: function() {

        return this.$store.msalApp;
      },
      $loggedInUser: function(){

          if ($msalClient){

            return this.$msalClient.eumUser;

          } else {
            return null;
          }
      }
  },
  watch: {
    $route(to) {
       const store = require('@/store/index');
      this.routerAction(to.path.split("/")[1]);
    }
  },
  mounted() {
    console.log(this);
    if (this.$route.path == "/dashboard") {
      this.submenu = false;
    } else {
      this.submenu = true;
    }
    this.routerAction(this.$route.path.split("/")[1]);
    this.mainRoutes = [
      {
        name: "comingsoon",
        route: "/home",
        label: "Home"
      },
      {
        name: "configuration",
        route: "/configuration/program",
        label: "Application Configuration"
      },
      {
        name: "event",
        route: "/event/issuance",
        label: "Business Event"
      },
      {
        name: "report",
        route: "/report/issuance",
        label: "Report"
      },
      {
        name: "valuation",
        route: "/valuation/investmentvaluation",
        label: "Valuation"
      },
      {
        name: "admin",
        route: "/admin/tracker",
        label: "Administration"
      }
    ];
  },
 
  methods: {
    copyText(){
      let copy = $('.copy_text').val();
       $('.copy_text').select();
      document.execCommand('copy');
    
        Swal.fire({
            icon: 'success',
            title: 'Text copied to clipboard',
            text: copy,
            showConfirmButton: false,
            timer: 3000
        });


    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    async Logout() {
      console.log("Logging out");
      await this.$parent.shallowLogout();
     
     
    },
    async GetToken(){
       let self=this;
       await this.$eumAuth.acquireToken();
       let tknval = this.$store.getters['authModule/api_idtoken'];
       self._MessagePopup(tknval);
       $(".swal2-content").css("font-size",".9em");
       $(".swal2-header").css("font-size",".9em");
       
    },
    routerAction: function(route) {
      this.initialroute = this.$route.path.split("/")[1];
      if (route == "home") {
        this.submenu = false;
      }
      if (route == "configuration") {
        this.submenu = true;
        let configuration = [
          {
            name: "configuration",
            route: "/configuration/program",
            label: "Program Information"
          },
          {
            name: "configuration",
            route: "/configuration/partner",
            label: "Partner Information"
          },
          {
            name: "configuration",
            route: "/configuration/investment",
            label: "Investment Information"
          }
        ];
        this.SubRoutes = configuration;
      } else if (route == "event") {
        this.submenu = true;
        let configuration = [
          {
            name: "event",
            route: "/event/initialissuance",
            label: "Initial Issuance"
          },
          {
            name: "event",
            route: "/event/issuance",
            label: "Issuance"
          },
          {
            name: "event",
            route: "/event/transfer",
            label: "Transfer"
          },
          {
            name: "event",
            route: "/event/vesting",
            label: "Vesting"
          },
          {
            name: "event",
            route: "/event/distribution",
            label: "Distribution"
          },
          {
            name: "event",
            route: "/event/buyout",
            label: "Buyout"
          }
          // ,
          // {
          // 	name:'event',
          // 	route:'/event/correction',
          // 	label:'Correction'
          // }
        ];
        this.SubRoutes = configuration;
      } else if (route == "report") {
        this.submenu = true;
        let configuration = [
          {
            name: "report",
            route: "/report/issuance",
            label: "Issuance Report"
          },
          {
            name: "report",
            route: "/report/transfer",
            label: "Transfer Report"
          },
          {
            name: "report",
            route: "/report/vesting",
            label: "Vesting Report"
          },
          {
            name: "report",
            route: "/report/buyout",
            label: "Buyout Report"
          },
          {
            name: "report",
            route: "/report/distribution",
            label: "Distribution Report"
          },
          //{
          // 	name:'report',
          // 	route:'/report/correction',
          // 	label:'Correction Report'
          // },
          {
            name: "report",
            route: "/report/program",
            label: "Program Report"
          },
          {
            name: "report",
            route: "/report/investor",
            label: "Investor Report"
          },
          {
            name: "report",
            route: "/report/partnercapital",
            label: "Partner Capital Report"
          }
        ];
        this.SubRoutes = configuration;
      } else if (route == "valuation") {
        this.submenu = true;
        let configuration = [
          {
            name: "valuation",
            route: "/valuation/investmentvaluation",
            label: "Investment Valuation"
          },
          {
            name: "valuation",
            route: "/valuation/allocation",
            label: "Unit Program Allocation"
          },
          {
            name: "valuation",
            route: "/valuation/directinvestment",
            label: "Direct Investment"
          },
          {
            name: "valuation",
            route: "/valuation/footnote",
            label: "Custom Footnote"
          },
          {
            name: "valuation",
            route: "/valuation/memo",
            label: "Custom Memo"
          },
          {
            name: "valuation",
            route: "/valuation/fmvs",
            label: "FMV Statement"
          }
        ];
        this.SubRoutes = configuration;
      } else if (route == "admin") {
        this.submenu = true;
        let configuration = [
          {
            name: "admin",
            route: "/admin/tracker",
            label: "Information Tracker"
          },
          {
            name: "admin",
            route: "/admin/document",
            label: "Document Manager"
          },
          {
            name: "admin",
            route: "/admin/InputControl",
            label: "Input Control"
          }
        ];
        this.SubRoutes = configuration;
      }
    },

    signOut() {
      

      const myMsal = new PublicClientApplication(config);

      // you can select which account application should sign out
      const logoutRequest = {
          account: this.$eumAuth.msalApp.getAccountByHomeId(homeAccountId)
      }
      myMsal.logoutRedirect(logoutRequest);
    },


copyToClipboard(str) {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText){
          return navigator.clipboard.writeText(str);
        }
        return Promise.reject('The Clipboard API is not available.');
      }
  }
  
};
</script>

<style scoped>
/* @media (min-width: 576px) { 
.navbar-expand-sm .navbar-nav .nav-link{
	padding: 15px 7px;
}
} */
</style>


<style>
@import "../../assets/styles/variables.scss";
header {
  width: 100%;
  color: #ffffff;
  padding:0px !important;
  margin: 0px !important;
  margin-left: 0px !important;
}

.header-title {
  font-size: 24px;
}

.user {
  font-size: 14px;
}

.nav-link {
  color: #ffffff !important;
  padding: 1.3em 1em !important;
}

.dropdown-menu.show {
  background: #333333;
  margin-top: 0px;
  border-radius: 0px;
}

a.dropdown-item {
  font-size: 14px;
  color: #ffffff;
}

a.dropdown-item.router-link-active {
  color: #ffe600 !important;
  font-weight: bold;
  text-decoration: none;
}

a.dropdown-item:hover,
.dropdown-item:focus {
  color: #16181b;
  background-color: $ey-yellow !important;
  text-decoration: none;
}
header {margin-right: -15px !important;}
nav.navbar {
  padding-bottom: 0.5px;
}
.row {margin-left: 0px !important;}
/* .row {
  margin-left:-15px !important;
  margin-right: -15px !important;
} */
.element2 {
    padding-left: 16px !important;
    padding-right: 16px !important;
    padding-top: 8px !important;
}
.subnavbar {
    padding: 0 65px!important;
}

li.nav-item {
  padding-right: 10px;
  text-decoration: none;
  font-size: 14px;
}

li a:hover {
  color: inherit;
}
.container-fluid {
margin: 0px !important;
padding:0px !important;
  }

.header-title img {
  vertical-align: inherit;
}

.navbar .router-link-active {
  color: #ffe600 !important;
  box-shadow: inset 0 -4px 0 #ffe600 !important;
}
.dropdown-item.router-link-active {
  box-shadow: none;
}
/* .dropdown-menu.show{
    display: block;
    color: white !important;
} */
.dropdown-toggle {
  color: white !important;
}
/* .menuDisplay a{
    color: white !important;
    text-decoration: none;
    background-color: transparent;
}
ul.dropdown-menu{
	border: none !important;
} */
.row.no-gutters.mt-2.pl-5{
  padding-left:48px !important;
  margin-top: 8px !important;
}
.my-2 {
    padding-left: 25px!important;
    padding-right: 25px!important;
}
.row {
  margin-right: -15px !important;
}
.row.no-gutters.justify-content-md-between.mt-4.ml-5{
  margin-left: 48px !important;
  margin-right: 0px !important;
}
span.menuDisplay .dropdown-menu {
  position: absolute;
  transform: translate3d(90px, 20px, 0px);
  top: 0px;
  left: 0px;
  will-change: transform;
  background-color: #ccc;
  color: #000;
  text-decoration: none;
}
span.menuDisplay .dropdown-menu:active,
span.menuDisplay .dropdown-menu:visited {
  color: #000;
  text-decoration: none;
}
span.menuDisplay .dropdown-menu a {
  color: #000;
  text-decoration: none;
  padding-left: 1em;
  display: table;
  width: 100%;
}
footer.footer {
  padding-top:10px !important;
  padding-left: unset;
  padding-right:unset;
  padding-bottom:unset;
}
</style>